import React, { type ReactNode } from 'react';

import { useIntl } from 'react-intl';

import { ProformaIntlProvider } from '@atlassian/proforma-utils/intl-provider/main';

import commonCoreLazyMessages from '../i18n/lazy';

interface Props {
	children: ReactNode;
	locale: string;
}

export const PackageIntlProvider: React.FC<Props> = ({ children, locale }) => (
	<ProformaIntlProvider locale={locale} messages={commonCoreLazyMessages}>
		{children}
	</ProformaIntlProvider>
);

/**
 * This is a simple HoC wrapper for PackageIntlProvider.
 */
export const withPackageIntlProvider =
	<Props extends Object>(WrappedComponent: React.ComponentType<Props>): React.FC<Props> =>
	(props) => {
		const intl = useIntl();
		return (
			<PackageIntlProvider locale={intl.locale}>
				<WrappedComponent {...props} />
			</PackageIntlProvider>
		);
	};

export { ProFormaIntlProvider, withProFormaIntlProvider } from './ProFormaIntlProvider';
